import styled from 'styled-components';

import Typography from '../Typography';

import { colors } from '@10d/tend-ui-tokens/samolet';

type IProps = {
  color?: string;
};

const Text = styled(Typography.Text)`
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  color: ${(props: IProps) => props.color || colors.gray900};
`;

export default Text;
